import Seatplans from '../../../store/seatplans/main/index';

angular
    .module('festzelt-os.seatplans')
    .factory('Seatplans', [
        '$injector',
        'Seatplan',
        ($injector, Seatplan) => new Seatplans(Seatplan, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/store/seatplans.js